import config from '../config';
import {
  removeRole,
  loadRoles,
  loadRole,
  addRole,
  updateRole,
 } from '../actions/roles';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';
import { updatePermissions } from "../actions/users";

export function removeRoleById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/roles/${data.id}`, {
          method: 'DELETE',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(removeRole({ id: data.id }));
            dispatch(notify({
              title: 'Role has removed',
              message: 'Role removed successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
}

export function fetchRoles() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/roles`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          dispatch(loadRoles({ list: json }));
        })
    }
  }
}

export function fetchRolesList() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/roles/list`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          dispatch(loadRoles({ listForSelect: json }));
        })
    }
  }
}

export function fetchRoleById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/roles/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadRole({ role: json }));
          }
        })
    }
  }
}

export function createRole(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/roles`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(addRole({ role: json }));
            dispatch(push('/pages/roles'));
            dispatch(notify({
              title: 'Add New Role',
              message: 'Role added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Role',
            message: 'Failed to add new role',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function updateRoleById(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/roles/${id}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(push('/pages/roles'));
            dispatch(updateRole({ role: json }));
            dispatch(updatePermissions({ permission: json.permissions, roleId: id }));
            dispatch(notify({
              title: 'Edit Role',
              message: 'Role edited successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Edit Role',
            message: 'Failed to edit role',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/roles.js